import React, {useState} from "react";
import {Link} from "react-router-dom";

export function PaymentDone(props) {
    return (
        <div className='content wrapper'>
            Оплата завершена.
        </div>
    )
}